// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rF12","content":"styles_content__Tu3wq"};